import { render, staticRenderFns } from "./infoPartner.vue?vue&type=template&id=5244a8d6&scoped=true&"
import script from "./infoPartner.vue?vue&type=script&lang=js&"
export * from "./infoPartner.vue?vue&type=script&lang=js&"
import style0 from "./infoPartner.vue?vue&type=style&index=0&id=5244a8d6&prod&lang=scss&"
import style1 from "./infoPartner.vue?vue&type=style&index=1&id=5244a8d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5244a8d6",
  null
  
)

export default component.exports